/* eslint-disable eqeqeq */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { Form, Col, Row, Input, Select, Table, Button, Checkbox, Modal } from "antd";
import type { UploadProps } from "antd/es/upload/interface";
import { CreateModal } from "./create-modal";
import { EditModal } from "./edit-modal";
import { useEffect, useState } from "react";
import type { ColumnsType } from "antd/es/table";
import { Routes } from "../../../../../../AppRoutes";
import { useHistory } from "react-router-dom";
import { CreateNotification } from "../../../../../../components/notifier";
import { Upload } from "antd";
import { IMaterialType } from "../../models";
import { HiOutlineTrash } from "react-icons/hi2";
import { UploadOutlined } from "@ant-design/icons";
import { getDDMMYYYFormat } from "../../../../../../helper/dateTimeHelper";
import { PlanningDepartmentExportService } from "../../../../../../services/planning-department/export-warehouse";
import { eContent } from "../../constant/field-names";
import { validatePhoneNumber } from "../../../../../../services/util";
import { useRouteMatch } from "react-router-dom";
import ExcelJS from "exceljs";
import moment from "moment";
import { StyledButton, StyledTitle } from "../../../../../../components/styled-antd";
import { getTemplate } from "../../../../../../components/input/arrayData/excel-template";
import { useExcelTemplate } from "../../../../../../components/input/arrayData/hooks/useExcelTemplate";
import _ from "lodash";

export function EditForm() {
  const [dataSource, setDataSource] = useState<any[]>([]);
  const [eTypeExportWarehouse, setETypeExportWarehouse] = useState("");
  const history = useHistory();
  const [form] = Form.useForm();
  const [isMultiDelete, setIsMultiDelete] = useState(false);
  const [listDelete, setListDelete] = useState<number[]>([]);
  const { exportFile } = useExcelTemplate();

  const onValuesChange = (changedValues: any) => {
    if (changedValues.eDepartment) {
      form.setFieldsValue({
        eApprovedBy: null,
        pickedUser: null,
      });
    }
  };

  const { id } = useRouteMatch().params as any;

  const [fileList, setFileList] = useState<any>([]);

  const initialData = async () => {
    const data = await PlanningDepartmentExportService.getDetail(id);

    setDataSource(JSON.parse(data.fields.eContent));

    try {
      if (Array.isArray(JSON.parse(data.fields.eFileContent))) setFileList(JSON.parse(data.fields.eFileContent));
    } catch (error) {
      alert(1);
      setFileList([]);
    }

    form.setFieldsValue({
      eTypeExportWarehouse: data.fields.eTypeExportWarehouse,
      eReason: data.fields.eReason,
      ePhoneNumber: data.fields.ePhoneNumber,
    });
  };

  useEffect(() => {
    initialData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const columns: ColumnsType<IMaterialType> = [
    {
      title: isMultiDelete ? (
        <Checkbox
          onClick={(e: any) => {
            if (e.target.checked) {
              setListDelete(_.range(0, dataSource.length));
            } else {
              setListDelete([]);
            }
          }}
        />
      ) : (
        ""
      ),
      dataIndex: "action",
      key: "action",
      render: (value: any, record: IMaterialType, index: number) => {
        index = (currentPage - 1) * pageSize + index;

        if (isMultiDelete) {
          return (
            <Checkbox
              checked={listDelete.includes(index)}
              onChange={(e) => {
                if (e.target.checked) {
                  let newListDelete = [...listDelete, index];
                  setListDelete(newListDelete);
                } else {
                  let newListDelete = [...listDelete];
                  newListDelete = newListDelete.filter((value): any => value != index);
                  setListDelete(newListDelete);
                }
              }}
            />
          );
        }

        return (
          <div className="flex">
            <EditModal dataSource={dataSource} setDataSource={setDataSource} index={index} />

            <Button
              onClick={() => {
                if ((dataSource.length - 1) % 10 == 0) {
                  const NUM_PAGES = Math.ceil(dataSource.length / pageSize);
                  if (currentPage >= 2 && currentPage === NUM_PAGES) {
                    setCurrentPage(currentPage - 1);
                  }
                }

                setDataSource((prev: any) => {
                  return prev.filter((value: any, indexValue: number) => indexValue != index);
                });
              }}
              className="ml-1"
            >
              <HiOutlineTrash size={20} className="cursor-pointer" color="#dc2626" />
            </Button>
          </div>
        );
      },
    },
    {
      title: "STT",
      dataIndex: "index",
      key: "index",
      render: (value: any, record: IMaterialType, index: number) => <>{(currentPage - 1) * pageSize + index + 1}</>,
    },
    {
      title: "Tên vật tư/ hàng hóa",
      dataIndex: eContent.productName,
      key: eContent.productName,
    },
    {
      title: "ĐVT",
      dataIndex: eContent.Dram,
      key: eContent.Dram,
    },
    {
      title: "Số lượng đề nghị",
      dataIndex: eContent.requestedQuantity,
      key: eContent.requestedQuantity,
    },
    {
      title: "Số lượng tồn tại đơn vị",
      dataIndex: eContent.inventoryQuantity,
      key: eContent.inventoryQuantity,
    },
    {
      title: "Thời gian sử dụng",
      dataIndex: eContent.productLifetime,
      key: eContent.productLifetime,

      render: (value: any, record: IMaterialType, index: number) => {
        return <>{getDDMMYYYFormat(value)}</>;
      },
    },
    {
      title: "Ghi chú",
      dataIndex: eContent.note,
      key: eContent.note,
    },
    {
      title: "Số lượng phê duyệt",
      dataIndex: eContent.approvedQuantity,
      key: eContent.approvedQuantity,
      render: (value: any, record: IMaterialType, index: number) => {
        return <></>;
      },
    },
  ];

  const props: UploadProps = {
    beforeUpload: async (file) => {
      const workbook = new ExcelJS.Workbook();
      const reader = new FileReader();
      reader.readAsArrayBuffer(file);

      reader.onload = async () => {
        const buffer: any = reader.result;
        const workbooks = await workbook.xlsx.load(buffer);

        let data: any[] = [];

        workbooks.eachSheet((sheet, sheetId) => {
          sheet.eachRow((row: any, rowIndex) => {
            data.push([...row.values].filter((value, index) => index != 0));
          });
        });

        data = data.filter((value, index) => index != 0);

        const dataSource: any[] = [];

        for (const item of data) {
          if (!Array.isArray(item) || item.length != 6) {
            CreateNotification({
              title: "Import file thất bại",
              body: `Vui lòng download biểu mẫu và nhập đúng thông tin.`,
              icon: "/icons/error.png",
            });
            return;
          }

          dataSource.push({
            [eContent.productName]: item[0],
            [eContent.Dram]: item[1],
            [eContent.requestedQuantity]: item[2],
            [eContent.inventoryQuantity]: item[3],
            [eContent.productLifetime]: moment(item[4], "DD/MM/YYYY"),
            [eContent.note]: item[5],
          });
        }

        setDataSource((prev) => [...prev, ...dataSource]);
      };

      return false;
    },
    showUploadList: false,
    fileList,
  };

  const handleChange: UploadProps["onChange"] = (info) => {
    let newFileList = [...info.fileList];

    // 1. Limit the number of uploaded files
    // Only to show two recent uploaded files, and old ones will be replaced by the new
    // newFileList = newFileList.slice(-2);

    // 2. Read from response and show file link
    newFileList = newFileList.map((file) => {
      if (file.response) {
        // Component will show file.url as link
        file.url = file.response.url;
      }
      return file;
    });

    setFileList(newFileList);
  };

  const props2: UploadProps = {
    name: "files",
    multiple: true,
    action: "https://viagsapi.azurewebsites.net/api/uploadfile/upload-file",
    onChange: handleChange,
    onPreview(file: any) {
      window.open(file?.response?.data?.[0]);
    },
  };

  const onFinish = async (values: any) => {
    if (dataSource.length === 0) {
      CreateNotification({
        title: "Thất bại",
        body: `Vui lòng nhập các thông tin yêu cầu`,
        icon: "/icons/error.png",
      });
      return;
    }

    try {
      // const resp = await PlanningDepartmentExportService.updateRequest(id, {
      //   Title: "Xuất kho",

      //   ePhoneNumber: values.ePhoneNumber,
      //   eContent: JSON.stringify(dataSource),
      //   eTypeExportWarehouse:
      //     values.eTypeExportWarehouse === "Khác" ? values.eOtherTypeExportWarehouse : values.eTypeExportWarehouse,
      //   eFileContent: JSON.stringify(fileList || []),
      // });
      CreateNotification({
        title: "Thành công",
        body: `Cập nhật phiếu yêu cầu thành công`,
        icon: "/icons/success.png",
      });
      history.push(Routes.procedureExportWarehouse.path);
    } catch (error) {
      CreateNotification({
        title: "Thất bại",
        body: `Cập nhật phiếu yêu cầu thất bại`,
        icon: "/icons/error.png",
      });
      history.push(Routes.procedureExportWarehouse.path);
    }
  };

  const downLoad = async () => {
    await exportFile(getTemplate("export-warehouse"));
  };

  const confirmDelete = () => {
    if ((dataSource.length - listDelete.length) % 10 == 0) {
      const NUM_PAGES = Math.ceil(dataSource.length / pageSize);
      if (currentPage >= 2 && currentPage === NUM_PAGES) setCurrentPage(currentPage - 1);
    }

    let newDataSource = [...dataSource];
    newDataSource = newDataSource.filter((value, index) => !listDelete.includes(index));
    setDataSource(newDataSource);
    setListDelete([]);
    setIsMultiDelete(false);
  };

  const showDeleteConfirm = () => {
    Modal.confirm({
      title: "Thông báo",
      content: "Anh/chị vui lòng xác nhận xoá các dữ liệu đã chọn!",
      okText: "Xác nhận",
      okType: "danger",
      okButtonProps: { type: "primary" },
      cancelText: "Huỷ",
      onOk() {
        confirmDelete();
      },
    });
  };

  const pageSize = 10; // Number of rows per page
  const [currentPage, setCurrentPage] = useState(1);

  return (
    <>
      <Form onFinish={onFinish} size="large" form={form} onValuesChange={onValuesChange}>
        <Row gutter={[32, 0]}>
          <Col span={12}>
            <StyledTitle level={5}>
              Lý do <span className="text-danger">(*)</span>
            </StyledTitle>
            <Form.Item name="eReason" rules={[{ required: true, message: "Nhập lí do" }]}>
              <Input />
            </Form.Item>
          </Col>

          <Col span={12}>
            <StyledTitle level={5}>
              Đề nghị xuất kho <span className="text-danger">(*)</span>
            </StyledTitle>
            <Form.Item name="eTypeExportWarehouse" rules={[{ required: true, message: "Chọn đề nghị xuất kho" }]}>
              <Select
                options={[
                  {
                    value: "All",
                    label: "All",
                  },
                  {
                    value: "Văn phòng phẩm",
                    label: "Văn phòng phẩm",
                  },
                  {
                    value: "Công cụ dụng cụ",
                    label: "Công cụ dụng cụ",
                  },
                  {
                    value: "Nguyên vật liệu",
                    label: "Nguyên vật liệu",
                  },
                  {
                    value: "Trang phục/BHLĐ",
                    label: "Trang phục/BHLĐ",
                  },
                  {
                    value: "Thiết bị/TTB",
                    label: "Thiết bị/TTB",
                  },
                  {
                    value: "Vật tư VSMB",
                    label: "Vật tư VSMB",
                  },
                  {
                    value: "Khác",
                    label: "Khác",
                  },
                ]}
                onChange={(value) => {
                  setETypeExportWarehouse(value);
                }}
              />
            </Form.Item>
          </Col>

          {eTypeExportWarehouse === "Khác" && (
            <Col span={24}>
              <StyledTitle level={5}>
                Khác (Ghi cụ thể) <span className="text-danger">(*)</span>
              </StyledTitle>
              <Form.Item name="eOtherTypeExportWarehouse" rules={[{ required: true, message: "Nhập số điện thoại" }]}>
                <Input />
              </Form.Item>
            </Col>
          )}

          <Col span={12}>
            <StyledTitle level={5}>
              Số điện thoại <span className="text-danger">(*)</span>
            </StyledTitle>
            <Form.Item
              name="ePhoneNumber"
              rules={[
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (validatePhoneNumber(value)) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error("Số điện thoại không hợp lệ."));
                  },
                }),
              ]}
            >
              <Input className="font-weight-normal" />
            </Form.Item>
          </Col>

          <Col span={12}>
            <StyledTitle level={5}>Đính kèm</StyledTitle>
            <Form.Item name="eFiles">
              <Upload {...props2} fileList={fileList}>
                <Button className="mx-3 ">
                  <UploadOutlined rev="data" />
                </Button>
              </Upload>
            </Form.Item>
          </Col>
        </Row>

        <Row>
          <Col>
            <StyledTitle level={5}>
              Chi tiết <span className="text-danger">(*)</span>
            </StyledTitle>
          </Col>
        </Row>

        <Row>
          <Col>
            <CreateModal dataSource={dataSource} setDataSource={setDataSource} />
          </Col>

          <Col>
            {!isMultiDelete && (
              <StyledButton bgColor="red" className="ml-3" type="primary" danger onClick={() => setIsMultiDelete(true)}>
                Chọn nhiều để xóa
              </StyledButton>
            )}

            {isMultiDelete && (
              <StyledButton
                className="ml-3"
                bgColor="green"
                onClick={() => {
                  setIsMultiDelete(false);
                  setListDelete([]);
                }}
              >
                Quay lại
              </StyledButton>
            )}

            {listDelete.length != 0 && (
              <StyledButton
                bgColor="red"
                className="ml-3"
                type="primary"
                danger
                onClick={() => {
                  showDeleteConfirm();
                }}
              >
                Xóa dữ liệu đã chọn
              </StyledButton>
            )}
          </Col>

          <Col>
            <Upload {...props}>
              <StyledButton bgColor="blue" className="mx-3 ">
                Tải biểu mẫu
              </StyledButton>
            </Upload>
          </Col>

          <Col>
            <div className="mt-1">
              <a href="#" className="text-primary" onClick={downLoad}>
                Download biểu mẫu tại đây
              </a>
            </div>
          </Col>
        </Row>

        <Table
          dataSource={dataSource}
          columns={columns}
          pagination={{
            onChange: (page) => {
              setCurrentPage(page);
            },
            current: currentPage,
          }}
          scroll={{
            x: "100vh",
          }}
        />

        <Row gutter={[32, 0]}>
          <Col span={24}>
            <div className="d-flex justify-content-center">
              <StyledButton
                bgColor="red"
                htmlType="submit"
                onClick={() => history.push(Routes.procedureExportWarehouse.path)}
              >
                Hủy
              </StyledButton>

              <StyledButton bgColor="yellow" type="primary" htmlType="submit" className="ml-3">
                Xác nhận
              </StyledButton>
            </div>
          </Col>
        </Row>
      </Form>
    </>
  );
}
